import React, { useState } from 'react';
import { Box, TextField, Typography, Button, Paper } from '@mui/material';
import { req } from './ServerUtils';
import { useUser } from './UserProvider';

const DiscoverySurveyForm = () => {
    const {userInfo} = useUser();
  const [formData, setFormData] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    req('/discovery-survey', 'POST', JSON.stringify(formData)).then((res) => {
        setShowSuccess(true);
    }).catch((err) => {
        console.log(err);
        setError(true);
    });
  };

    if (showSuccess) {
        return (
            <Paper elevation={3} sx={{ p: 4, maxWidth: 700, mx: 'auto', mt: 4 }}>
            <Typography variant="h5" gutterBottom>Thank you for submitting the discovery survey! We will get back to you soon.</Typography>
            </Paper>
        );
    }
    if (error) {
        return (
            <Paper elevation={3} sx={{ p: 4, maxWidth: 700, mx: 'auto', mt: 4 }}>
                <Typography variant="h5" gutterBottom>Error submitting the discovery survey. Please try again.</Typography>
            </Paper>
        );
    }


  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 700, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>MakeMyBrand Discovery Survey</Typography>
      <Typography variant="body2" paragraph>
        Hello {userInfo?.info?.name || userInfo?.email},
        This survey is a part of the discovery phase of our LinkedIn growth program. Answers are vital to successfully executing the program.
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" label="What is your LinkedIn URL?" name="linkedinURL" onChange={handleChange} />
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" multiline rows={3} label="Who is your Target Audience?" name="audience" onChange={handleChange} />
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" label="Which countries are you targeting?" name="countries" onChange={handleChange} />
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" multiline rows={2} label="How did your previous followers find you?" name="channels" onChange={handleChange} />
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" multiline rows={3} label="What software & tools do you use to create & post content on LinkedIn?" name="tools" onChange={handleChange} />
        <TextField required inputProps={{ minLength: 5 }} fullWidth margin="normal" multiline rows={3} label="What are your short & long-term expectations from the LinkedIn Growth Program?" name="expectations" onChange={handleChange} />
        <Button variant="contained" type="submit" sx={{ mt: 2 }}>Submit</Button>
      </Box>
    </Paper>
  );
};

export default DiscoverySurveyForm;
